module.exports = __webpack_public_path__ + "img/diamond_smile.b84a6c50.svg";